import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import type { IGrade } from '@/Module/Grade/Model/DataModel';
import { prepareLessonUrl } from '@/Module/Lesson/Helper/prepareLessonUrl';
import type { ILesson } from '@/Module/Lesson/Model/DataModel';

export const prepareGradeBreadCrumb = (course: ILesson, grade?: IGrade, needCourseLink = false): IBreadcrumbItem[] => {
  const courseBreadcrumb: IBreadcrumbItem = {
    key: 'COURSE',
    title: course?.title ?? '',
    href: needCourseLink
      ? prepareLessonUrl({
          gradeSeoUrlSlug: grade?.seoUrlSlug ?? 'grade',
          seoUrlSlug: course.seoUrlSlug,
          id: course.id,
        })
      : undefined,
  };

  if (!grade) return [courseBreadcrumb];

  if (grade.breadcrumb.length === 2) {
    const [firstGrade, secondGrade] = grade.breadcrumb;

    return [
      {
        key: `GRADE_${firstGrade.entityId}`,
        title: firstGrade.title,
        href: LINKS.GRADE,
      },
      {
        key: `GRADE_${secondGrade.entityId}`,
        title: `پایه ${secondGrade.title}`,
        href: secondGrade.link,
      },
      courseBreadcrumb,
    ];
  }

  if (grade.breadcrumb.length === 3) {
    const [firstGrade, secondGrade, lastGrade] = grade.breadcrumb;

    return [
      {
        key: `GRADE_${firstGrade.entityId}`,
        title: firstGrade.title,
        href: LINKS.GRADE,
      },
      {
        key: `GRADE_${lastGrade.entityId}`,
        title: `پایه ${secondGrade.title} ${lastGrade.title}`,
        href: lastGrade.link,
      },
      courseBreadcrumb,
    ];
  }

  return [
    ...grade.breadcrumb.map((item, index) => ({
      key: `GRADE_${item.entityId}`,
      title: item.title,
      href: index === 0 ? LINKS.GRADE : item.link,
    })),
    courseBreadcrumb,
  ];
};
